import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { theme } from "@config/theme-config";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { ReactNode } from "react";
export function ThemeProvider({
  children
}: {
  children: ReactNode;
}) {
  return <>
      <MantineProvider theme={theme} data-sentry-element="MantineProvider" data-sentry-source-file="theme-provider.tsx">
        <Notifications position="top-center" data-sentry-element="Notifications" data-sentry-source-file="theme-provider.tsx" />
        <ModalsProvider data-sentry-element="ModalsProvider" data-sentry-source-file="theme-provider.tsx">{children}</ModalsProvider>
      </MantineProvider>
    </>;
}